import { createSelector } from "@reduxjs/toolkit";
import { FormRootState } from "./formStore";

export const selectNeurologicModels = createSelector(
	(state: FormRootState) => state.neurologicWeaknessReview.models,
	(models) => models
)

export const selectCombinedIcdDesc = (state: FormRootState, icd: string, includeCodeInDesc: boolean) => 
	selectNeurologicModels(state).filter(item => (item.code1 === icd) || (item.code2 === icd))
		.map(match => [match.site, match.etiology, includeCodeInDesc ? match.type.concat(' ', icd) : match.type])
		.map(descArr => descArr.join(', '))
		.join(' | ')